import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import Moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import '../../../assets/css/siicex-usuario.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import React, { Component, useRef } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_RECURSOS, BASE_URL_CMS, BASE_URL_FRONTEND} from '../../../constants';
import Error from '../../Error/error';
import {stateToHTML} from 'draft-js-export-html';
import {DropDownList} from '../../Elements/Select/dropdown';
import Select from 'react-select';
import {DropDownListChild} from '../../Elements/Select/dropdown';
import cookie from 'react-cookies';
import ImageUploader from 'react-images-upload';
import PdfFirstPagePreview from '../../Elements/PdfPreview/pdf-preview';
import {toBase64, hasSpecificRole} from '../../../functions';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../functions';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BulletinIcon from '@material-ui/icons/EventNote';
import ContenidoIcon from '@material-ui/icons/LineStyle';
import ImagenIcon from '@material-ui/icons/Image';
import DocumentIcon from '@material-ui/icons/AttachFile';
import VideoIcon from '@material-ui/icons/VideoLibrary';
import InfoIcon from '@material-ui/icons/HelpOutline';
import Checkbox from '@material-ui/core/Checkbox';
import ReactPlayer from 'react-player'
import { DropDownListMaster } from '../../Elements/Select/dropdownChild';
import { DropDownListChildMaster } from '../../Elements/Select/dropdownChild';
import {DropDownGeneral} from '../../Elements/Select/dropdownChild';
import {ValidateState} from '../../../functions';
import CKEditor from 'ckeditor4-react';

import ModalMultimedia from '../../Partials/ModalMultimedia';
import { validateImageFile, fetchImageDimensions, fetchImagePesoMaximo ,   cargarConfiguracionRoles, getCKEditorConfig, callCambiaEstado} from './utils';
import {BotoneraCrud, BotoneraEstados, navegarTab} from './Botonera';
import { useUnsavedChanges } from '../../Root/UnsavedChangesContext';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
  useHistory,
  useParams,
} from 'react-router-dom';
import TagInput from '../../Elements/TagInput/TagInput';


let config = {    
  height : '400px',
  width :'100%',
  toolbar: [
        { name: 'clipboard', items: [ 'Cut', 'Undo', 'Redo' ] },
        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'RemoveFormat' ] },
        { name: 'links', items: [ 'Link', 'Unlink' ] }
    ],
addCss: '.divImagenConBajada img{width: 100% !important;}',

stylesSet : [
  { name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
  { name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
  { name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
  { name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
  { name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
  { name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
],
div_wrapTable : true,
extraAllowedContent: 'section class iframe style video embed',
allowedContent : true,
image: {toolbar: [ 'imageTextAlternative' ]},
extraPlugins : 'embed, iframe',
embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
skin : 'kama'
}

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}>
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };


    const getFileBase64 = (file, callback) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => callback(reader.result);
        reader.onerror = error => {};
    };

    const uploadImageCallBack = file => new Promise(
    (resolve, reject) => getFileBase64(
        file,
        data => resolve({ data: { link: data } })
    )
    );

    let countCaracteresResumenPdf = 0;
    let countCaracteresMotivoRechazo = 0;
    const LIMITE_CARACTERES_RESUMEN = 3000;

class edit_recurso extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            editorState: EditorState.createEmpty(),
            editorStateHTML : '' ,
            pictures: [],
            editorStateB: EditorState.createEmpty(),
            editorStateHTMLB : '' ,
            security: cookie.load('user'),
            roles: [],
            sector: [],
            userModified: [],
            userCreated: [],
            edit: false,
            roles: [],
            numeroTab: 0,
            HTML: '<span>&nbsp</span>',
            fieldReturnMultimedia:"",
            imagesToSelect: false,
            selectedImage: false,
            selectedFile: false,
            imageLimitDimension: null,
            imageLimitePesoBytes: null,
            imageDimensionError: '',
            
            isComboAprobadorBlocked: false,
          }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onEditorChangeEdit = this.onEditorChangeEdit.bind(this); 
        this.onEditorChangeEditResumen = this.onEditorChangeEditResumen.bind(this); 
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.currentImagePage = 1;
        this.asignDefaultImage = this.asignDefaultImage.bind(this);
        this.handleProductoChange = this.handleProductoChange.bind(this);
    
        const limiteMbImagen = 1; 
        this.imageLimitePesoBytes = limiteMbImagen * 1024 * 1024;
        this.VALIDAR_IMAGEN_AL_GRABAR = true;
    }

    onEditorChangeEdit(evt) {
      if (evt.editor!==undefined)
      {
        let html = evt.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource["sContenido"] = html;
        this.setState({
          resource: copyResource, 
          HTML: html
        }, ()=> {});
      }
    }

    onEditorChangeEditResumen(evt, campo="") {
      let html = evt.editor.getData();
      let caracteres = html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g ,'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length;

      if (caracteres > LIMITE_CARACTERES_RESUMEN) {
        // Se excedió el límite: se revierte el editor al último contenido válido en vez de aceptar el exceso.
        // Cubre tipeo, pegado, arrastrar-y-soltar y deshacer/rehacer, ya que todos disparan este mismo evento 'change'.
        if (this._revirtiendoResumen) { return; } // evita reentrancia por el propio setData() de abajo
        this._revirtiendoResumen = true;
        toast.warn(`El resumen alcanzó el límite de ${LIMITE_CARACTERES_RESUMEN} caracteres.`);
        evt.editor.setData(this.state.resource[campo] || '', {
          callback: () => { this._revirtiendoResumen = false; }
        });
        return;
      }

      let copyResource = JSON.parse(JSON.stringify(this.state.resource));
      copyResource[campo] = html;

      document.getElementById("count-caracteres-"+ campo).innerHTML = caracteres
      countCaracteresResumenPdf = caracteres;

      this.setState({
          resource: copyResource
      });
    }

    handleInputChange(event) {
        if (event && typeof event.persist === 'function') event.persist();

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        if(event.target.id === "sArchivoNombre"){
          let texto = event.target.value.toLocaleLowerCase();
          let textoOri = event.target.value;
          let letras = "abcdefghijklmnopqrstuvwxyz0123456789-.";
          let _valueO = '';

          for (var i = 0; i < texto.length; i++) {
            if (letras.indexOf(texto[i]) != -1) {
              _valueO += textoOri[i];
            }
          }

          event.target.value = _valueO;
          copyResource['sArchivoNombre'] = _valueO;
        }

        else if(event.target.id === "sTitulo"){
          let textoOriginal = event.target.value;
          let regexCaracterValido = /[a-zA-Z0-9À-ÿÑñ ]/;
          let _valueTitulo = '';

          for (var j = 0; j < textoOriginal.length; j++) {
            if (regexCaracterValido.test(textoOriginal[j])) {
              _valueTitulo += textoOriginal[j];
            }
          }

          event.target.value = _valueTitulo;
          copyResource['sTitulo'] = _valueTitulo;
        }
        else{
          copyResource[target.name] = value; 
        }

        if(target.name === "nSectorCodigo")
        {
            copyResource["nSectorCodigo"] = value;
        }

        if(target.name === 'sOrigen'){
            const sOrigenTexto = (value && typeof value === 'object') ? (value.value || '') : (value || '');
            if(sOrigenTexto.toString().trim().toUpperCase() !== 'PROMPERÚ'){
                copyResource['sAutor'] = '';
            }
        }

        this.setState({
          resource: copyResource
      });
    }

    changeTagInput(name, val){
      let copyResource = JSON.parse(JSON.stringify(this.state.resource));
      copyResource[name] = val;
      this.setState({ resource: copyResource });
    }

  handleProductoChange(event) {
        const selectedOptions = event.target.value; 
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource['listProductosSelected'] = selectedOptions;

        let productoNombres = '';
        if (selectedOptions && selectedOptions.length > 0) {
            productoNombres = selectedOptions.map(option => option.label).join(',');
        }
        
        copyResource['sProducto'] = productoNombres;
        this.setState({ resource: copyResource });
    }

    loadCategoriasManual = (idTipo) => {
        const id = (idTipo && typeof idTipo === 'object') ? idTipo.value : idTipo;
        
        if (!id || id === 0 || id === "0") {
            this.setState({ listCategorias: [] });
            return;
        }

        axios.get(`${API_URL}CategoryUX/${id}`)
            .then(res => {
                this.setState({ listCategorias: res.data.result || [] });
            })
            .catch(err => console.error(err));
    }

   async componentDidMount(){
        await fetchImageDimensions().then(limits => {this.setState({ imageLimitDimension: limits });});
        await fetchImagePesoMaximo().then(maxMB => {this.setState({ imageLimitePesoBytes: maxMB * 1024 * 1024 });});

        localStorage.setItem("load", false);
        this.getImages()

        let search = window.location.search;
        let params = new URLSearchParams(search);

        const { handle } = this.props.match.params

        var key = this.props.location.state.key;

        const url = `${API_URL}ResourceUX/${key}/0`;
        axios.get(url).then(response => response.data)
        .then((data) => {
          
          let dataRes = data.result;
          console.log(url, dataRes)
          
        // --- estad2026
        const MAPA_ESTADOS = {
            "R": "Borrador",       
            "X": "Por aprobar",
            "O": "Por publicar",
            "P": "Publicado",
            "I": "Inactivo",
            "Z": "Rechazado"
        };

        //  INICIO ADAPTADOR  
        if (dataRes) {
            // Extraemos el ID puro (como número) para que el combo reconozca la selección
            const fId = (dataRes.nFormato && typeof dataRes.nFormato === 'object') ? dataRes.nFormato.value : dataRes.nFormato;
            dataRes.nFormato = parseInt(fId, 10) || 0;

            const aId = (dataRes.nAprobador && typeof dataRes.nAprobador === 'object') ? dataRes.nAprobador.value : dataRes.nAprobador;
            dataRes.nAprobador = parseInt(aId, 10) || 0;

            if (dataRes.cEstado && typeof dataRes.cEstado === 'string') {
                dataRes.sEstado = MAPA_ESTADOS[dataRes.cEstado] || "Desconocido";
                dataRes.cEstado = { value: dataRes.cEstado, label: dataRes.sEstado };
            }

            if (!dataRes.sArchivoNombre || dataRes.sArchivoNombre === "") {
                dataRes.sArchivoNombre = dataRes.sUrlCanonical || dataRes.recu_SeoUrlCanonical || "";
            }
        }
        //  FIN ADAPTADOR  

            if (dataRes.lResourceItem) {
                dataRes.listPartida = dataRes.lResourceItem.map(item => ({
                    value: item.part_Id,
                    label: item.part_Nombre || item.part_Descripcion || item.part_Id 
                }));
            } else {
                dataRes.listPartida = [];
            }            

           if (dataRes.sProducto && dataRes.sProducto.length > 0) {
                dataRes.listProductosSelected = dataRes.sProducto.split(',').map(nombre => ({
                    value: nombre,
                    label: nombre 
                }));
            } else {
                dataRes.listProductosSelected = [];
            }

              if (dataRes.sProducto && dataRes.sProducto.length > 0) {
                  dataRes.listProductosSelected = dataRes.sProducto.split(',').map(item => ({
                      value: item, // Usamos el nombre como valor temporal
                      label: item
                  }));
              } else {
                  dataRes.listProductosSelected = [];
              }

            dataRes.lBitacoraAprobacion = dataRes.lBitacoraAprobacion || [];

            this.setState({
               resource: dataRes || '', 
               response: data, 
               error: data.Error 

              }, ()=> {
                // Snapshot para detectar cambios sin guardar (¿Quieres guardar los cambios antes de salir?)
                this.initialResourceSnapshot = JSON.stringify(this.state.resource);

                this.loadCategoriasManual(dataRes.nTipoRecursoCodigo);

                const resumenHTML = this.state.resource.recu_ResumenPdf || '';
                const blocksFromHTML = convertFromHTML(resumenHTML);
                const editorState = (blocksFromHTML && blocksFromHTML.contentBlocks)
                  ? EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML))
                  : EditorState.createEmpty();

                this.setState({ editorState }, () => {
                    document.querySelector('.loader').classList.add('loader--hide');
                    document.getElementById('content-wrapper').removeAttribute("hidden");
                });

                let caracteres = (blocksFromHTML && blocksFromHTML.contentBlocks)
                  ? resumenHTML.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g, 'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length
                  : 0;

                const contadorElemento = document.getElementById("count-caracteres-recu_ResumenPdf");
                if (contadorElemento) {contadorElemento.innerHTML = caracteres;}
                countCaracteresResumenPdf = caracteres;

                // roles-ini
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const config = JSON.parse(localStorage.getItem('config') || '{}');
                const userId = user.nUsuCodigo ? user.nUsuCodigo.toString() : "";

                let isSuperAdmin = String(user.Tusu_EsSuperAdmin).toLowerCase() === "true";
                let isAprobador = config.aprobador && config.aprobador.split(',').includes(userId);
                
                const idAprobadorAsignado = this.state.resource.nAprobador?.value || this.state.resource.nAprobador;
                isAprobador = isAprobador && (userId === String(idAprobadorAsignado));
                
                let isPublicador = config.publicador && config.publicador.split(',').includes(userId);
                let isCreador = !isSuperAdmin && !isAprobador && !isPublicador;
                
                const esComboEditable = !( isSuperAdmin || ( isCreador && ( this.state.resource.cEstado?.value == "R" || this.state.resource.cEstado?.value == "Z" ) ));
                this.setState({ isComboAprobadorBlocked: esComboEditable });
                
                // roles-fin
                
                axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioModificacion}/ /1`)
                .then(response => response.data)
                .then((dataResult) => {
                    this.setState({userModified: dataResult.result},() => {
                      axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioCreacion}/ /1`)
                      .then(response => response.data)
                      .then((dataResult) => { this.setState({userCreated: dataResult.result},
                          () => {
                            document.querySelector('.loader').classList.add('loader--hide');
                            document.getElementById('content-wrapper').removeAttribute("hidden");
                          });
                      });
                    });
                });

              });
              
        })
        .catch(error => {
            console.log(error);
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            toast.error("¡Error al inicializar!");
        });

              await cargarConfiguracionRoles();

              // Registrar en el Context: cómo saber si hay cambios sin guardar, y cómo guardar.
              if (this.props.registerFormGuard) {
                  this.props.registerFormGuard(this.hasUnsavedChanges, this.saveForExit);
              }
}

    componentWillUnmount(){
        if (this.props.clearFormGuard) {
            this.props.clearFormGuard();
        }
    }

    // Compara el resource actual contra el snapshot tomado al cargar la pantalla.
    hasUnsavedChanges = () => {
        if (!this.initialResourceSnapshot) return false;
        return JSON.stringify(this.state.resource) !== this.initialResourceSnapshot;
    }

    // Guarda como "Borrador"/estado actual (mismo comportamiento que el botón Guardar existente)
    // y, solo si el guardado fue exitoso, ejecuta onSuccess (la navegación pendiente: logout/home).
    saveForExit = (onSuccess) => {
        const letra = (this.state.resource.cEstado && this.state.resource.cEstado.value) || "R";
        const valorAccion = letra === "R" ? "Borrador" : "GrabarCerrar";
        callCambiaEstado(this, null, valorAccion, "", "", onSuccess);
    }


    handleClickCancel(e){
      const { requestNavigation, history } = this.props;
      const goTo = () => history.push({ pathname: '/recurso' });
      if (requestNavigation) {
          requestNavigation(goTo);
      } else {
          goTo();
      }
    }

    // Mismo patrón que Header.js/handleLogoClick: intercepta la navegación de los enlaces
    // del breadcrumb (Panel de Configuración General, Recursos) si hay cambios sin guardar,
    // mostrando el modal de confirmación en vez de navegar directo.
    handleBreadcrumbClick = (e, pathname) => {
        e.preventDefault();
        const { requestNavigation, history } = this.props;
        const goTo = () => history.push({ pathname });
        if (requestNavigation) {
            requestNavigation(goTo);
        } else {
            goTo();
        }
    }

    async asignDefaultImage (codigo, data){
      const tipo = (codigo && typeof codigo === 'object') ? codigo.value : codigo;
      if (!tipo) return;
      const url = `${API_URL}CategoryUX/ObtenerCategoriaRecurso/${tipo}`;
      try{
          const res = await axios.get(url);
          if(res.data && res.data.result){
              const result = res.data.result;
              const defaultImg = result.imagenPorDefecto;
              if (data) {
                  data.sImagen = defaultImg;
              } else {
                  // fallback: actualizar estado si no se pasó data
                  this.setState(prev => ({
                      resource: updateValueInJson(prev.resource, 'sImagen', defaultImg)
                  }));
              }
          }
      } catch(err){
      }
    }

    validarFormularioCompleto = () => {
        let _isOk = true;
        const r = this.state.resource;

        if (ValidateState(r, 'sTitulo', '')) {  toast.error('Ingrese un título para el documento'); _isOk = false; }
        if (ValidateState(r, 'cRec_Id', '0')) { toast.error('Seleccione la temática del documento'); _isOk = false; }

        const formatoVal = r.nFormato?.value ?? r.nFormato;
        if (!formatoVal || formatoVal == 0 || formatoVal == "0") { toast.error('Seleccione el formato del documento'); _isOk = false; }

        const fechaVal = r.dFechaPublicacion;
        if (!fechaVal || fechaVal.toString().trim() === '') { toast.error('Seleccione la fecha del documento'); _isOk = false; }

        const sOrigenTexto = (r.sOrigen && typeof r.sOrigen === 'object') ? (r.sOrigen.value || '') : (r.sOrigen || '');
        if (!sOrigenTexto || sOrigenTexto.toString().trim() === '') { toast.error('Seleccione el autor del documento'); _isOk = false; }

        const estadoActual = r.cEstado?.value || r.cEstado || "R";

        // El documento (PDF) solo es obligatorio al solicitar aprobación (único destino
        // posible desde Borrador/Rechazado). Antes vivía en utils.js/callCambiaEstado;
        // se consolida aquí para que su mensaje salga junto con el resto, en el orden pedido.
        if (estadoActual === "R" || estadoActual === "Z") {
            const enlace = r.sEnlaceDocumento;
            if (!enlace || enlace.trim() === '') { toast.error('Adjunte un documento'); _isOk = false; }

            const nAprobadorVal = r.nAprobador?.value ?? r.nAprobador;
            if (!nAprobadorVal || nAprobadorVal == 0 || nAprobadorVal == "0") {
                toast.error('Para solicitar la aprobación, seleccione un aprobador');
                _isOk = false;
            }
        }

    return _isOk;
};


    // #save #guardar #grabar
    callFunctionButton = async (event, letraPropuesta = null, motivoRechazo = "", modoCRUD="", estadoAnterior = null, onSuccessCallback = null) => {
        if (event) { event.preventDefault(); }
      
        if (this.VALIDAR_IMAGEN_AL_GRABAR && this.state.selectedImage) {
            const val = await validateImageFile(
                this.state.selectedImage, 
                this.state.imageLimitDimension, 
                this.state.imageLimitePesoBytes
            );

            if (!val.ok) {
                toast.error(val.message);
                this.setState({loading: false}); 
                return; 
            }
        }

        let _isOk = true; 
        let tipoRecurso = this.state.resource.nTipoRecursoCodigo;
        let nAprobador = this.state.resource.nAprobador;

        // if(tipoRecurso != 14)
        {
            if (modoCRUD !== "GrabarCerrar")
            {
                if(countCaracteresResumenPdf > LIMITE_CARACTERES_RESUMEN){toast.error(`Error en Validación: Resumen del PDF supera el límite de los ${LIMITE_CARACTERES_RESUMEN} caracteres.`); _isOk = false;}
                if(countCaracteresMotivoRechazo != 0 && countCaracteresMotivoRechazo > 2000) {toast.error('Error en Validación: Motivo de rechazo supera el límite de los 2000 caracteres.'); _isOk = false;}
            }
        }

        if(!_isOk) { return; }

        this.setState({loading:true});

        const {history: {push}} = this.props;
        const url             = `${API_URL}ResourceUX/`;

        // var dataToSave        = this.state.resource;
         var dataToSave        = JSON.parse(JSON.stringify(this.state.resource));
        dataToSave            = updateValueInJson(dataToSave, 'nUsuarioModificacion', this.state.security.nUsuCodigo);

        var nUbicacionCodigo  = this.state.resource.nUbicacionCodigo;
        var nSectorCodigo     = this.state.resource.nSectorCodigo;
        var listPartida       = this.state.resource.listPartida;
        var listLineaProducto = this.state.resource.listLineaProducto;
        var sProducto   = this.state.resource.sProducto;

        // NUEVO CÓDIGO (SEGURO)
        var ubicacion     = Array.isArray(nUbicacionCodigo) ? nUbicacionCodigo.map(v => v.value) : (this.state.resource.lResourceCountry ? this.state.resource.lResourceCountry.map(v => v.pais_Id) : []);
        var sector        = Array.isArray(nSectorCodigo) ? nSectorCodigo.map(v => v.value) : (this.state.resource.lResourceSector ? this.state.resource.lResourceSector.map(v => v.nSectorCodigo) : []);
        var partida       = Array.isArray(listPartida) ? listPartida.map(v => v.value) : (this.state.resource.lResourceItem ? this.state.resource.lResourceItem.map(v => v.part_Id) : []);
        var lineaProducto = Array.isArray(listLineaProducto) ? listLineaProducto.map(v => v.value) : (this.state.resource.lResourceLineaProducto ? this.state.resource.lResourceLineaProducto.map(v => v.lpro_Id) : []);

        var sAutor    = this.state.resource.sAutor ;
        var sOrigen    = this.state.resource.sOrigen;

        dataToSave = updateValueInJson(dataToSave,'listLineaProducto', String(lineaProducto));
        dataToSave = updateValueInJson(dataToSave,'listPais', String(ubicacion));
        dataToSave = updateValueInJson(dataToSave,'listSector', String(sector));
        dataToSave = updateValueInJson(dataToSave,'listPartida', String(partida));
        dataToSave = updateValueInJson(dataToSave,'nLineaProductoCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nUbicacionCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nSectorCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nTipoRecursoCodigo', (this.state.resource.nTipoRecursoCodigo.value?this.state.resource.nTipoRecursoCodigo.value:this.state.resource.nTipoRecursoCodigo));

        const aprobadorRaw = this.state.resource.nAprobador?.value ?? this.state.resource.nAprobador;
        dataToSave = updateValueInJson(dataToSave, 'nAprobador', parseInt(aprobadorRaw, 10) || 0);

        const formatoRaw = this.state.resource.nFormato?.value ?? this.state.resource.nFormato;
        dataToSave = updateValueInJson(dataToSave, 'nFormato', parseInt(formatoRaw, 10) || 0);
        
        dataToSave = updateValueInJson(dataToSave,'sSector', String(sector));
        dataToSave = updateValueInJson(dataToSave, 'sRolCRUD', this.state.resource.sRolCRUD || "");
        dataToSave = updateValueInJson(dataToSave, 'sAccionCRUD', modoCRUD || "");
        dataToSave = updateValueInJson(dataToSave,'cEstado', (this.state.resource.cEstado.value?this.state.resource.cEstado.value:this.state.resource.cEstado));
        dataToSave = updateValueInJson(dataToSave, 'bActivo', true);
        dataToSave = updateValueInJson(dataToSave,'recu_NotificarPorPush',   (this.state.resource.recu_NotificarPorPush.value ? this.state.resource.recu_NotificarPorPush.value : this.state.resource.recu_NotificarPorPush));
        dataToSave = updateValueInJson(dataToSave,'recu_NotificarPorCorreo', (this.state.resource.recu_NotificarPorCorreo.value ? this.state.resource.recu_NotificarPorCorreo.value : this.state.resource.recu_NotificarPorCorreo));
        dataToSave = updateValueInJson(dataToSave, 'Recu_SeoSeguirEnlace', !!(this.state.resource.recu_SeoSeguirEnlace?.value ?? this.state.resource.recu_SeoSeguirEnlace));
        dataToSave = updateValueInJson(dataToSave, 'Recu_SeoMostrarMotores', !!(this.state.resource.recu_SeoMostrarMotores?.value ?? this.state.resource.recu_SeoMostrarMotores));
        dataToSave = updateValueInJson(dataToSave,'cRec_Id', (this.state.resource.cRec_Id.value?this.state.resource.cRec_Id.value:this.state.resource.cRec_Id));
        dataToSave = updateValueInJson(dataToSave,'sUsuario', this.state.security.sUsuNombre + ' ' + this.state.security.sUsuApellidoPaterno);
        dataToSave = updateValueInJson(dataToSave,'sAutor', sAutor.value ? sAutor.value : '')
        dataToSave = updateValueInJson(dataToSave,'sOrigen', sOrigen.value ? sOrigen.value : '')
        dataToSave = updateValueInJson(dataToSave,'sProducto', sProducto ? sProducto : '')
        dataToSave.Recu_SeoSeguirEnlace = Boolean(dataToSave.recu_SeoSeguirEnlace);
        dataToSave.Recu_SeoMostrarMotores = Boolean(dataToSave.recu_SeoMostrarMotores);
        dataToSave.bActivo = (String(dataToSave.bActivo) === "true");
        dataToSave.sComentario = motivoRechazo || this.state.resource.sComentario || "";
        dataToSave.sRolCRUD = this.state.resource.sRolCRUD || "";
        
        if (!dataToSave.sImagen || dataToSave.sImagen === "") {
             let typeCode = this.state.resource.nTipoRecursoCodigo.value 
                           ? this.state.resource.nTipoRecursoCodigo.value 
                           : this.state.resource.nTipoRecursoCodigo;
            
            await this.asignDefaultImage(typeCode, dataToSave);
        }

        let valAprobador = dataToSave.nAprobador?.value ?? dataToSave.nAprobador;
        dataToSave.nAprobador = isNaN(parseInt(valAprobador, 10)) ? 0 : parseInt(valAprobador, 10);
        
        let valFormato = dataToSave.nFormato?.value ?? dataToSave.nFormato;
        dataToSave.nFormato = isNaN(parseInt(valFormato, 10)) ? 0 : parseInt(valFormato, 10);
        
        let valEstado = letraPropuesta || dataToSave.cEstado?.value || dataToSave.cEstado;
        dataToSave.cEstado = valEstado?.value ?? valEstado;

        // Validaciones preGuardar
        if (modoCRUD !== "GrabarCerrar" &&  !(dataToSave.cEstado == "R" || dataToSave.cEstado == "I") && ( dataToSave.nAprobador == 0 || dataToSave.nAprobador == "0") ) {
            toast.error('Error: Debe seleccionar un Aprobador.');
            this.setState({ loading: false });
            return;
        }

        if (modoCRUD !== "GrabarCerrar" && dataToSave.cEstado === "X" && (!dataToSave.nAprobador || dataToSave.nAprobador == 0 || dataToSave.nAprobador == "0")) {
            toast.error('Error: Debe seleccionar un Aprobador para solicitar la aprobación.');
            this.setState({ loading: false });
            return;
        }

        // Validaciones preGuardar:End
        
        delete dataToSave.lResourceSector;
        delete dataToSave.lResourceCountry;
        delete dataToSave.lResourceItem;
        delete dataToSave.lResourceLineaProducto;

        const formData = JSON.stringify(dataToSave);
        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
        ).then((data)=> {
              document.querySelector('.loader').classList.add('loader--hide');
              document.getElementById('content-wrapper').removeAttribute("hidden");

              if (data.data.isSucess && data.data.result){
                
                  if (onSuccessCallback) {
                      // Viene del flujo "Guardar y salir": el guardado fue exitoso,
                      // se continúa con la acción original (logout / ir al home) en vez de navegar al listado.
                      onSuccessCallback();
                  } else {
                      toast.success('Recurso registrado correctamente. \n Se redireccionará al listado de recursos');
                      this.props.history.push({pathname: '/recurso',});
                  }

              } else {
                  this.setState(prevState => ({
                      loading: false,
                      resource: estadoAnterior ? {
                          ...prevState.resource,
                          cEstado: estadoAnterior.cEstado,
                          sEstado: estadoAnterior.sEstado,
                      } : prevState.resource,
                  }));
                  toast.error(data.data.statusMessage || 'No se pudo registrar el Recurso. \r');
              }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
    }

    onEditorStateChange = (event) => {
        let html = event.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource["sContenido"] = html;

        this.setState({
            resource: copyResource
        });
    };

    HandlePastedText = (text, html, editorState, onChange) => {
    }

    handleInputChangeDate(control){
        Moment.locale('es');
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format('YYYY-MM-DD') + Moment().format('[T]HH:mm:ss.SSS');
         this.setState({resource: copyResource});
    }

    // La librería ImageUploader rechaza archivos con extensión/tamaño inválido
    // de forma interna, sin llegar a invocar onDrop (solo actualiza su propio
    // estado fileErrors). Por eso el error de dimensión de un intento anterior
    // (imageDimensionError) puede quedar pegado en pantalla junto al nuevo
    // mensaje de la librería. Se limpia acá, al primer clic sobre el selector,
    // en vez de depender de que onDrop se ejecute.
    clearImageDimensionError = () => {
        if (this.state.imageDimensionError) {
            this.setState({ imageDimensionError: '' });
        }
    }

    onDrop = async (file_container, flag) => {
        if (file_container.length < 1) return;

        const file = file_container[0];
        if (!file) {
            this.setState({ [flag]: false });
            return;
        }

        if (flag === 'selectedImage') {
        const result = await validateImageFile(
            file, 
            this.state.imageLimitDimension, 
            this.state.imageLimitePesoBytes
        );

        if (!result.ok) {
            toast.error(result.message);
            this.setState({ selectedImage: false, imageDimensionError: result.message });
            return;
        }

        this.setState({ imageDimensionError: '' });
    }

    toBase64(file).catch(e => {
        if (flag === 'selectedImage') {
            toast.error("Ocurrió un error al analizar la imagen, por favor seleccione otra");
        } else {
            toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro");
        }
        this.setState({ [flag]: false }); 
    }).then(data => {
        let _tmp = {};
        _tmp[flag] = file;
        _tmp[flag].base64 = data;
        this.setState(_tmp);
    });
}

    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };

    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/imagenes/all/all`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }

    selectImage = (img_obj) => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }

    unSelectImage = () => {
        let _tmp = updateValueInJson(this.state.resource, 'sImagen', "");
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', 0);
        this.setState({ 
            resource: _tmp,
            selectedImage: false, 
            uploaderKey: Date.now(),
            imageDimensionError: ''
        });
    }
    
    unSelectDoc = () => {
        let _tmp = {};
        _tmp = updateValueInJson(this.state.resource, 'sEnlaceDocumento', "");
        _tmp = updateValueInJson(_tmp, 'nArchivoCodigo', 0); 
        _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', "");

        this.setState({ resource: _tmp, selectedFile: false });
    }

  uploadImage = async () => { 
    let _file = this.state.selectedImage;
    
    if (!_file) {
        toast.error("No hay ninguna imagen seleccionada para subir.");
        return;
    }

    const r = await validateImageFile(
        _file, 
        this.state.imageLimitDimension, 
        this.state.imageLimitePesoBytes
    );

    if (!r.ok) {
        toast.error(r.message);
        return;  
    }
    
    let formData = {};
    let _filename = _file.name
    formData.sArchivoNombre = _filename;
    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
    formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
    formData.sArchivoTipo = "imagenes"
    formData.sCategoriaArchivo = ""
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Espere mientras la imagen es procesada")
    axios.post((API_URL+`FileUX/`),
        ("'"+JSON.stringify(formData)+"'"),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
    ).then( data => {
        toast.success("La imagen ha sido subida correctamente")

        let _tmp = {};
        _tmp = updateValueInJson(this.state.resource, 'sImagen', data.data.result.sArchivoRuta)
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo)
        this.setState({resource: _tmp}, this.getImages());
    }).catch((error)=> {
        console.error(error);
        toast.error('Error al subir la imagen');
    });
}

uploadFile = async() => {
    let _isOk = true;
    if(ValidateState(this.state.resource, 'sArchivoNombre', '')){ toast.error('Error en Validación: Debe ingresar el nombre del documento.'); _isOk = false; }

    let _file = this.state.selectedFile;

    if (!_file) {
        toast.error("Debe seleccionar un archivo PDF.");
        return;
    }

    if(!_isOk){return;}

    let formData = {};
    let _filename = _file.name
    let _extension = _filename.substring(_filename.lastIndexOf(".") + 1, _filename.length);
    // sArchivoNombre puede venir ya con extensión (ej. "titulo.pdf"), porque tras cada subida
    // el backend devuelve el nombre completo con extensión y ese valor se guarda en el estado.
    // Se quita cualquier extensión previa antes de concatenar, para no duplicarla (evitar "titulo.pdf.pdf").
    let _sArchivoNombreSinExtension = this.state.resource.sArchivoNombre.replace(/(\.[^./\\]+)+$/, '');

    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
    formData.sArchivoExtension = _extension
    formData.sArchivoNombre = `${_sArchivoNombreSinExtension}.${_extension}`;
    formData.sArchivoTipo = "documentos"
    formData.sCategoriaArchivo = ""
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Espere mientras el documento es procesado, esto puede tomar hasta un minuto...")
    
    axios.post((API_URL+`FileUX/`),
      ("'"+JSON.stringify(formData)+"'"),
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
        }
      }
    ).then( data => {
      if (!data.data || !data.data.isSucess || !data.data.result) {
        console.error('Respuesta sin éxito al subir el documento:', data.data);
        toast.error(
          (data.data && data.data.statusMessage) ||
          'No se pudo subir el documento. Verifique el tamaño/formato e intente nuevamente.'
        );
        return;
      }

      toast.success("El documento ha sido subido correctamente")

      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'nArchivoCodigo', data.data.result.nArchivoCodigo);
      _tmp = updateValueInJson(_tmp, 'sEnlaceDocumento', data.data.result.sArchivoRuta);
      _tmp = updateValueInJson(_tmp, 'sArchivoNombre', data.data.result.sArchivoNombre);
      _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', data.data.result.sArchivoNombre);
      this.setState({resource: _tmp});
    }).catch((error)=> {
      console.error(error);
      toast.error('Error al subir el archivo');
    });
}

    paginationTable(){
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }
   
    letrasNumeroBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnñopqrstuvwxyz0123456789-.";
      
        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    letrasCanonicalBlur = (e) => {
      let texto = e.target.value.toLowerCase();
      let textoOri = e.target.value;
      let result = "";
      let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";
    
      for (var i = 0; i < texto.length; i++) {
        if (letras.indexOf(texto[i]) != -1) {
          result += textoOri[i];
        }
      }
      e.target.value = result;
      this.handleInputChange(e);
    }

    getResponse = (urlSeleccionada) => {
      let resource = this.state.resource;
      let fieldReturn = this.state.fieldReturnMultimedia;

      if(fieldReturn!== ""){

          resource[fieldReturn] = urlSeleccionada;

          this.setState({resource:resource, fieldReturnMultimedia:""});
      }

      hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
      this.setState({fieldReturnMultimedia:campo});
      showModalPageClass(clase);
    }

    render(){
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        let isSuperAdmin = user.Tusu_EsSuperAdmin === true || user.Tusu_EsSuperAdmin === "true";

        const { editorState } = this.state;
        const userCookie = this.state.security || {};
        const currentCKEditorConfig = getCKEditorConfig(isSuperAdmin);
        
        Moment.updateLocale('en', {months : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]});
        Moment.updateLocale('en', {weekdays : [ "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]});
        
        return (
                (this.state.response.statusCode===200)?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                 <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/" onClick={(e) => this.handleBreadcrumbClick(e, '/')}>
                                                    / Panel de configuración general
                                                </a>
                                                <a href="/recurso" onClick={(e) => this.handleBreadcrumbClick(e, '/recurso')}>
                                                    / Recursos
                                                </a>
                                            <span> / Editar documento</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Editar documento
                                    </div>

                                <div className="content-option">
                                        <div className="row ">
                                            <div className="col-md-12">
                                                <AppBar position="static" color="default" >
                                                    <Tabs   value={this.state.numeroTab} onChange={this.handleChangeTab}
                                                            scrollButtons="auto"
                                                            aria-label="icon label tabs example"
                                                            variant="fullWidth"
                                                            indicatorColor="secondary"
                                                            textColor="secondary">
                                                                <Tab label="General" {...a11yProps(0)} />
                                                                <Tab label="Documento" {...a11yProps(1)} />
                                                                <Tab label="Resumen" {...a11yProps(2)} />
                                                                <Tab label="Imagen" {...a11yProps(3)} />
                                                                <Tab label="Estados" {...a11yProps(4)} />
                                                    </Tabs>
                                                </AppBar>
                                                <TabPanel value={this.state.numeroTab} index={0}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nRecursoCodigo"><strong>Código</strong></label>
                                                                    <input type="text" readOnly name="nRecursoCodigo" onChange={this.handleInputChange} id="nRecursoCodigo" defaultValue={this.state.resource.nRecursoCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                                </div>
                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nTipoRecursoCodigo"><strong>Tipo</strong></label>
                                                                    <div className="col-sm-12">
                                                                        {/* <DropDownListMaster tipo={"padre"} valorHijo={this.state.resource.cRec_Id} valor={this.state.resource.nTipoRecursoCodigo} child="Categoria" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo"  onChange={this.handleInputChange} clave={this.state.resource.nTipoRecursoCodigo} componente={"TipoRecurso"} /> */}
                                                                        <input type="hiddens" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo" 
                                                                            value={
                                                                                (this.state.resource && this.state.resource.nTipoRecursoCodigo)
                                                                                ? (this.state.resource.nTipoRecursoCodigo.value || this.state.resource.nTipoRecursoCodigo)
                                                                                : 15
                                                                            } 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="sTitulo"><strong>Título (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <input type="text" name="sTitulo" id="sTitulo"  maxLength={1024} onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} className="form-control text-filter__form-control" placeholder="Ingrese el título del documento"  />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Temática (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <Select
                                                                            classNamePrefix="select"
                                                                            inputId="cRec_Id"
                                                                            name="cRec_Id"
                                                                            placeholder="Seleccione la temática"
                                                                            options={(this.state.listCategorias || []).map(cat => ({ value: cat.crec_Id, label: cat.crec_Nombre }))}
                                                                            value={
                                                                                (this.state.listCategorias || [])
                                                                                    .filter(cat => cat.crec_Id === (this.state.resource.cRec_Id?.value || this.state.resource.cRec_Id))
                                                                                    .map(cat => ({ value: cat.crec_Id, label: cat.crec_Nombre }))[0] || null
                                                                            }
                                                                            onChange={(selected) => {
                                                                                this.handleInputChange({
                                                                                    target: { name: 'cRec_Id', value: selected ? selected.value : 0, type: 'dropdow' }
                                                                                });
                                                                            }}
                                                                            isSearchable={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Formato (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={this.state.resource.nFormato} isMulti={false} name="nFormato" id="nFormato"  onChange={this.handleInputChange} clave={this.state.resource.nFormato}
                                                                            componente={"RECURSO-FORMATO"}
                                                                             placeholder="Seleccione el formato" 
                                                                            ></DropDownList>
                                                                    </div>
                                                                </div>
                                                            <div className="form-group">
                                                                <label ><strong>Fecha del documento (*)</strong></label>
                                                                <br/> 
                                                                <div className="col-sm-12 tab-general-date">
                                                                    <DatePicker
                                                                        className="form-control text-filter__form-control_date"
                                                                        onChange={this.handleInputChangeDate}
                                                                        maxDate={new Date()}
                                                                        value={Moment(this.state.resource.dFechaPublicacion).format('DD/MM/YYYY')}/>
                                                                </div>
                                                            </div>
                                                                <div id='div-sresumen' className="form-group ocultar">
                                                                    <label htmlFor="sResumen"><strong>Resumen</strong></label>
                                                                    <input type="text" name="sResumen" id="sResumen" onChange={this.handleInputChange} defaultValue={this.state.resource.sResumen} className="form-control text-filter__form-control" placeholder="Resumen" />
                                                                </div>
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sOrigen"><strong>Organización </strong></label>
                                                                      <input type="text" name="sOrigen" id="sOrigen" onChange={this.handleInputChange} defaultValue={this.state.resource.sOrigen} className="form-control text-filter__form-control" placeholder="Organización" />
                                                                </div> */}
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sAutor"><strong>Unidad organizacional</strong></label>
                                                                    <input type="text" name="sAutor" id="sAutor" onChange={this.handleInputChange} defaultValue={this.state.resource.sAutor} className="form-control text-filter__form-control" placeholder="Unidad organizacional" />
                                                                </div> */}

                                                                <div className="form-group">
                                                                    <label htmlFor="sOrigen" className='h6'>
                                                                        <strong>Autor (*)</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={this.state.resource.sOrigen} isMulti={false} name="sOrigen" id="sOrigen"  onChange={this.handleInputChange} clave={this.state.resource.sOrigen}
                                                                            componente={"Recurso_Organizacion"}  placeholder="Seleccione el autor" 
                                                                        />
                                                                    </div>
                                                                </div> 
                                                                <div className="form-group">
                                                                    <label htmlFor="sAutor" className='h6'>
                                                                        <strong>Unidad organizacional</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList key={(() => {
                                                                                const origen = this.state.resource.sOrigen;
                                                                                const sOrigenTexto = (origen && typeof origen === 'object') ? (origen.value || '') : (origen || '');
                                                                                return 'sAutor-' + sOrigenTexto.toString().trim().toUpperCase();
                                                                            })()} valor={this.state.resource.sAutor} isMulti={false} name="sAutor" id="sAutor"  onChange={this.handleInputChange} clave={this.state.resource.sAutor} 
                                                                            componente={"Recurso_OrganizacionUnidad"}  placeholder="Seleccione la unidad organizacional" 
                                                                            isDisabled={(() => {
                                                                                const origen = this.state.resource.sOrigen;
                                                                                const sOrigenTexto = (origen && typeof origen === 'object') ? (origen.value || '') : (origen || '');
                                                                                return sOrigenTexto.toString().trim().toUpperCase() !== 'PROMPERÚ';
                                                                            })()}
                                                                        />
                                                                    </div>
                                                                </div>   

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="nUbicacionCodigo"><strong>Mercado(s)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={this.state.resource.lResourceCountry} isMulti={true} name="nUbicacionCodigo" id="nUbicacionCodigo"  onChange={this.handleInputChange} clave={this.state.resource.lResourceCountry} componente={"Ubicacion"} placeholder="Seleccione uno o más mercados" />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="nSectorCodigo">
                                                                      <strong>Sector(es)</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList 
                                                                          valor={this.state.resource.lResourceSector} 
                                                                          clave={this.state.resource.lResourceSector} 
                                                                          name="nSectorCodigo" 
                                                                          id="nSectorCodigo" 
                                                                          valorHijo={this.state.resource.lResourceLineaProducto}
                                                                          valorHijoPartida={this.state.resource.lResourceItem}
                                                                          child={["LineaProducto", "PartidaCascada"]}
                                                                          onChange={this.handleInputChange} 
                                                                          tipo="padre"
                                                                          componente={"Sector"} 
                                                                         placeholder="Seleccione uno o más sectores" 
                                                                          isMulti={true} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group ocultar">
                                                                    <label htmlFor="listPartida"><strong>Producto asociado</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList
                                                                          name="sProducto" 
                                                                          id="sProducto" 
                                                                          valor={this.state.resource.listProductosSelected || []}
                                                                          clave={this.state.resource.listProductosSelected || []}
                                                                          metodo="added"
                                                                          etiqueta={"Producto"} 
                                                                          onChange={this.handleProductoChange}
                                                                          componente={"Productos"}         
                                                                          isMulti={true}
                                                                        />
                                                                    </div>
                                                                </div>         
                                                                <div className="form-group">
                                                                    <label htmlFor="listLineaProducto">
                                                                      <strong>
                                                                        Línea(s)
                                                                      </strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChild  
                                                                          isMultiple={true}  
                                                                          name="listLineaProducto" 
                                                                          onChange={this.handleInputChange}  
                                                                          parent="Sector" 
                                                                          id="listLineaProducto" 
                                                                          componente={"LineaProducto"} 
                                                                          placeholder="Seleccione una o más líneas" 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="listPartida"><strong>Partida(s)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChild 
                                                                            name="listPartida" 
                                                                            id="listPartida"  
                                                                            isMultiple={true}
                                                                            clave={this.state.resource.listPartida}
                                                                            onChange={this.handleInputChange} 
                                                                            parent="Sector" 
                                                                            componente={"PartidaCascada"} 
                                                                            placeholder="Seleccione una o más partidas" 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="Recu_PalabrasClave">
                                                                        <strong>Palabras clave complementarias</strong>
                                                                    </label>
                                                                    <div className="col-sm-12 tab-general-palabras">
                                                                        <TagInput 
                                                                            defaultValue={this.state.resource['recu_PalabrasClave']}
                                                                            name="Recu_PalabrasClave" 
                                                                            id="Recu_PalabrasClave"
                                                                            onChange={(val) => this.changeTagInput('Recu_PalabrasClave', val)} 
                                                                            placeholder="Ingrese palabras clave separadas por un espacio"
                                                                            className="react-datepicker-wrapper"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                  <span> [{this.state.resource.sEstado}] </span>

                                                            </div>

                                                            {/* <div className="ocultar">
                                                                    <DropDownList valor={this.state.resource.cEstado} name="cEstado" id="cEstado"  onChange={this.handleInputChange} clave={this.state.resource.cEstado} componente={"Estado"} />
                                                                </div> */}
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="bActivo">
                                                                  <strong>Activo</strong>
                                                                </label>
                                                                <div className="">
                                                                    <DropDownList 
                                                                      valor={this.state.resource.bActivo} 
                                                                      name="bActivo" 
                                                                      id="bActivo"  
                                                                      onChange={this.handleInputChange} 
                                                                      clave={this.state.resource.bActivo} 
                                                                      componente={"Activo"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-4" style={{display:'none'}}>
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div id='tab1-portada' className="form-group">
                                                                    <label htmlFor="bPortada"><strong>Portada</strong></label>
                                                                    <div className="bPortada">
                                                                        <Checkbox  name="bPortada" id="bPortada" onChange={this.handleInputChange} value={this.state.resource.bPortada} checked={this.state.resource.bPortada} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div id='tab1-noticia' className="form-group">
                                                                    <label htmlFor="bImportante"><strong>Noticia Banner</strong></label>
                                                                    <div className="bImportante">
                                                                        <Checkbox  name="bImportante" id="bImportante" onChange={this.handleInputChange} checked={this.state.resource.bImportante} value={this.state.resource.bImportante} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notipush' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorPush">
                                                                        <strong>Notificar por push</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorPush">
                                                                        <Checkbox  
                                                                            name="recu_NotificarPorPush" 
                                                                            id="recu_NotificarPorPush" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Notificar por push" 
                                                                            checked={this.state.resource.recu_NotificarPorPush}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notimail' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorCorreo">
                                                                        <strong>Notificar por correo</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorCorreo">
                                                                        <Checkbox  
                                                                            name="recu_NotificarPorCorreo" 
                                                                            id="recu_NotificarPorCorreo" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorCorreo} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                               
                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceInteres"><strong>Enlace a recursos externos</strong></label>
                                                                    <input type="text" name="sEnlaceInteres" id="sEnlaceInteres" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceInteres} className="form-control text-filter__form-control" placeholder="Enlace a recursos externos" />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={1}>
                                                    <div className="row">
                                                        <div className="col-md-12 ">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sArchivoNombre"><strong>Nombre Documento</strong></label>
                                                                 <input type="text" name="sArchivoNombre"
                                                                  className="form-control text-filter__form-control"
                                                                  value={this.state.resource.sArchivoNombre || ''} 
                                                                  readOnly id="sArchivoNombre"
                                                                  style={{padding: "15px", backgroundColor: "#e9ecef"}} />
                                                            </div>
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <style>{`
                                                                  .doc-uploader-wrapper .errorMessage {
                                                                    font-size: 0 !important;
                                                                  }
                                                                  .doc-uploader-wrapper .errorMessage::before {
                                                                    content: "El archivo no cumple con el formato o parámetro permitido.";
                                                                    font-size: 12px;
                                                                    color: red;
                                                                  }
                                                                `}</style>
                                                                <br></br>
                                                                <div className="doc-uploader-wrapper">
                                                                <ImageUploader
                                                                  imgExtension={['pdf']}
                                                                  accept='.pdf'
                                                                  onChange={(file)=>this.onDrop(file,"selectedFile")}
                                                                  buttonText='Elija un documento'
                                                                  label="Formato: PDF. Tamaño máximo: 40 MB."
                                                                  id="Uploader" singleImage={true} withIcon={false}
                                                                  withPreview={false} maxFileSize={41943040}
                                                                  />
                                                                </div>
                                                                <PdfFirstPagePreview
                                                                  file={this.state.selectedFile || null}
                                                                  width={500}
                                                                  height={450}
                                                                />
                                                                <button disabled={!this.state.selectedFile}
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  onClick={this.uploadFile}>
                                                                    Subir el documento
                                                                </button>
                                                                &nbsp;&nbsp;
                                                                <button type="button" className="btn btn-primary btn-color-rojo-borde" onClick={this.unSelectDoc}>Eliminar el documento</button>
                                                                <br/>
                                                                <br/>
                                                                <div className="form-group">
                                                                    <strong>Enlace al documento: </strong>&nbsp;
                                                                    { 
                                                                      !this.state.resource.sEnlaceDocumento
                                                                      ? ""
                                                                      : (
                                                                        <a id="span-sEnlaceDocumento" target='_blank' href={BASE_URL_RECURSOS + this.state.resource.sEnlaceDocumento}>
                                                                          {this.state.resource.sEnlaceDocumento}
                                                                        </a>
                                                                      )
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={2}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <label><strong>Ingrese el resumen del documento</strong></label>
                                                                <CKEditor
                                                                    data={this.state.resource.recu_ResumenPdf || ''}
                                                                    onChange={(e) => this.onEditorChangeEditResumen(e, "recu_ResumenPdf")}
                                                                    config={currentCKEditorConfig}
                                                                    id="recu_ResumenPdf"
                                                                    name="recu_ResumenPdf"
                                                                />
                                                                <label htmlFor="recu_ResumenPdf-recu_ResumenPdf" style={{textAlign:'right', display:'block'}}><strong><span id='count-caracteres-recu_ResumenPdf'>0</span>/{LIMITE_CARACTERES_RESUMEN} caracteres</strong></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={3}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sTituloImagen"><strong>Título Imagen</strong></label>
                                                                <input type="text" name="sTituloImagen"
                                                                  className="form-control text-filter__form-control"
                                                                  defaultValue={this.state.resource.sTituloImagen||""}
                                                                  onChange={this.handleInputChange} id="sTituloImagen"
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Título archivo" />
                                                            </div>

                                                            {/* <div className="boletin__filters section__margin-bottom">
                                                                <button
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#thumbnail-modal">
                                                                    {this.state.resource.sImagen?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                                </button>
                                                            </div> */}
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <style>{`
                                                                  .img-uploader-wrapper .errorsContainer::before {
                                                                    content: "";
                                                                  }
                                                                  .img-uploader-wrapper.hay-error-dimension .errorsContainer::before {
                                                                    content: "El archivo no cumple con el formato o parámetro permitido.";
                                                                    display: block;
                                                                    font-size: 12px;
                                                                    color: red;
                                                                    text-align: center;
                                                                  }
                                                                  .img-uploader-wrapper .errorMessage {
                                                                    font-size: 0 !important;
                                                                  }
                                                                  .img-uploader-wrapper .errorMessage::before {
                                                                    content: "El archivo no cumple con los formatos o parámetros permitidos.";
                                                                    font-size: 12px;
                                                                    color: red;
                                                                  }
                                                                `}</style>
                                                                <div
                                                                  className={"img-uploader-wrapper" + (this.state.imageDimensionError ? " hay-error-dimension" : "")}
                                                                  onClick={this.clearImageDimensionError}
                                                                >
                                                                <ImageUploader
                                                                  key={this.state.uploaderKey}
                                                                  imgExtension={['.jpg', '.gif', '.png', '.jpeg']}
                                                                  accept='.jpg,.jpeg,.gif,.png'
                                                                  onChange={(file)=>this.onDrop(file,"selectedImage")}
                                                                  buttonText='Elija una imagen'
                                                                  label={`Formatos: JPG, JPEG, GIF o PNG. Dimensiones: ${this.state.imageLimitDimension ? `${this.state.imageLimitDimension.width}x${this.state.imageLimitDimension.height}` : '960x600'} píxeles. Tamaño máximo: 5 MB.`}
                                                                  id="Uploader" singleImage={true} withIcon={false}
                                                                  withPreview={true} maxFileSize={5242880}
                                                                  />
                                                                </div>
                                                                <div className="mb-2">
                                                                    <span style={{fontSize:'11px'}}>IMPORTANTE: Verifique que la imagen que utilizará no infringe los derechos de autor de terceros y cuenta con todas las autorizaciones de uso.</span>
                                                                </div>                                                                  
                                                                <div>
                                                                    <button disabled={!this.state.selectedImage}
                                                                    type="button" className="btn btn-primary btn-primary__tool"
                                                                    onClick={this.uploadImage}>
                                                                        Subir imagen
                                                                    </button>
                                                                    &nbsp;&nbsp;
                                                                    <button type="button" className="btn btn-primary btn-color-rojo-borde" onClick={this.unSelectImage}>Eliminar imagen</button>
                                                                </div>
                                                                <br/>
                                                                <div className="form-group">
                                                                    <strong>Enlace a imagen: </strong>&nbsp;
                                                                    {
                                                                      !this.state.resource.sImagen
                                                                      ? ""
                                                                      : (
                                                                        <a id="span-sEnlaceImagen" target='_blank' href={BASE_URL_RECURSOS + (this.state.resource.sImagen.startsWith('/') ? this.state.resource.sImagen : '/' + this.state.resource.sImagen)}>
                                                                          {this.state.resource.sImagen}
                                                                        </a>
                                                                      )
                                                                    }
                                                                </div>    
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 ocultar">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                {!this.state.resource.sImagen
                                                                  ? (<h6>No se ha seleccionado ninguna imagen</h6>)
                                                                  : (
                                                                    <div>
                                                                      <img className="col-md-12"
                                                                        src={BASE_URL_RECURSOS + this.state.resource.sImagen} />
                                                                      <br/><br/>
                                                                      {/* <button type="button" className="btn btn-primary btn-primary__tool" onClick={this.unSelectImage}>Elimina imagen</button> */}
                                                                    </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={4}>
                                                    <div className="row "  >
                                                         <div className="col-md-12 " >
                                                            <div className="row" style={{background:'white'}}>
                                                                <div className="col-md-4" >
                                                                    <div className=" section__margin-top" style={{marginTop:'10px'}}>
                                                                        <div className="form-group">
                                                                            <label htmlFor="recu_SeoTitulo"><strong>Aprobador</strong></label>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <DropDownList
                                                                                valor={this.state.resource.nAprobador}
                                                                                etiqueta={"APROBADOR"}
                                                                                metodo="added"
                                                                                name="nAprobador"
                                                                                id="nAprobador"
                                                                                onChange={this.handleInputChange}
                                                                                clave={this.state.resource.nAprobador}
                                                                                componente={"RES_CMS_APROBADOR"}
                                                                                placeholder="Seleccione un aprobador"
                                                                                isDisabled={this.state.isComboAprobadorBlocked}
                                                                            />
                                                                        </div>
                                                                        {/* <div className="form-group">
                                                                        </div>
                                                                        <div className="txtFile x-1 relative">
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                               <div className="col-md-8">
                                                                <div className="section__margin-top" >
                                                                    <div className="form-group botonera" style={{ marginTop: '55px' }}>
                                                                        <div className="row mb-3">
                                                                            <div className="col-12">
                                                                                <BotoneraEstados parent={this} momentoCrud={"edit"} />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                            <div className="divTablaPage_Panel">
                                                                <div className="table-responsive">
                                                                    <table border={1} cellSpacing={0} className="table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="table-bordered-radius--left">Fecha y hora</th>
                                                                                <th>Estado</th>
                                                                                <th>Usuario</th>
                                                                                <th className="table-bordered-radius--right">Motivo de rechazo</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.resource.lBitacoraAprobacion && this.state.resource.lBitacoraAprobacion.length > 0 ? (
                                                                                this.state.resource.lBitacoraAprobacion.map((item, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            {item.fecha || '---'}
                                                                                        </td>
                                                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                                                                {item.estado || '-'}
                                                                                        </td>
                                                                                        <td>{item.usuario || ''}</td>
                                                                                        <td>{item.comentario || ''}</td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="4" className="text-center">No hay registros en la bitácora de aprobación.</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                                                                                                
                                                         </div>
                                                        <div className="col-md-4 ocultar" >
                                                            <div className="boletin__filters section__margin-bottom" >
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoTitulo"><strong>SEO Título</strong></label>
                                                                    <input type="text" name="recu_SeoTitulo" id="recu_SeoTitulo" onChange={this.handleInputChange} maxLength={70} defaultValue={this.state.resource.recu_SeoTitulo} className="form-control text-filter__form-control" placeholder="SEO Título (70 caracteres)" />
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoDescripcion"><strong>SEO Descripción</strong></label>
                                                                    <textarea name="recu_SeoDescripcion" id="recu_SeoDescripcion" onChange={this.handleInputChange} maxLength={140} defaultValue={this.state.resource.recu_SeoDescripcion} className="form-control text-filter__form-control" placeholder="SEO Descripción (140) caracteres" style={{height: "100px"}}></textarea>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoUrlCanonical"><strong>SEO Url Canonical</strong></label>
                                                                    <input type="text" name="recu_SeoUrlCanonical" id="recu_SeoUrlCanonical" onBlur={this.letrasCanonicalBlur} onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoUrlCanonical} className="form-control text-filter__form-control" placeholder="SEO Url canonical" />
                                                                </div>
                                                                <div className="txtFile x-1 relative">
                                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "recu_SeoImagen")}/>
                                                                    <input type="text" placeholder="SEO Imagen" name='recu_SeoImagen' value={this.state.resource.recu_SeoImagen} maxLength={1000} onChange={this.handleInputChange} className="form-control text-filter__form-control"/>
                                                                </div>
                                                            </div>
                                                            <ModalMultimedia className="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
                                                        </div>
                                                        <div className="col-md-4 ocultar" >
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoSeguirEnlace">
                                                                      <strong>Seguir enlace</strong></label>
                                                                    <div className="recu_SeoSeguirEnlace">
                                                                        <Checkbox  
                                                                            name="recu_SeoSeguirEnlace" 
                                                                            id="recu_SeoSeguirEnlace" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Seguir enlace" 
                                                                            checked={this.state.resource.recu_SeoSeguirEnlace} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoMostrarMotores">
                                                                      <strong>Mostrar motores</strong></label>
                                                                    <div className="recu_SeoMostrarMotores">
                                                                        <Checkbox  
                                                                            name="recu_SeoMostrarMotores" 
                                                                            id="recu_SeoMostrarMotores" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Mostrar motores" 
                                                                            checked={this.state.resource.recu_SeoMostrarMotores} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoScript"><strong>SEO Script</strong></label>
                                                                    <textarea name="recu_SeoScript" id="recu_SeoScript" onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoScript} className="form-control text-filter__form-control" placeholder="Pegue aquí su código javascript" style={{height: "127px"}}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </div>
                                        </div>
                                        <div className="row botonera">
                                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                                <div style={{ minWidth: '120px' }}>
                                                {this.state.numeroTab > 0 && (
                                                    <button type="button" onClick={() => navegarTab(this, -1)} className="btn btn-danger btn-primary__submit btn-color-rojo-full">{"<< Anterior"}</button>
                                                )}
                                                </div>
                                                <div className="d-flex gap-2">
                                                     <BotoneraCrud parent={this} momentoCrud={"edit"} />
                                                </div>
                                                <div style={{ minWidth: '120px', textAlign: 'right' }}>
                                                    {this.state.numeroTab < 4 && (
                                                        <button type="button" onClick={() => navegarTab(this,1)} className="btn btn-success btn-primary__submit btn-color-verdefull">{"Siguiente >>"}</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>

                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se está generando el Boletín HTML espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.paginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
              }

}

// Wrapper funcional: permite usar el hook useUnsavedChanges y pasarlo como prop
// al formulario (que sigue siendo un componente de clase, sin tocar su lógica interna).
// NOTA: JSX distingue componentes de etiquetas HTML por la primera letra del nombre;
// como la clase se llama "edit_recurso" (minúscula), no se puede usar directamente como
// <edit_recurso .../> en JSX (React la trataría como una etiqueta HTML desconocida).
// Se usa React.createElement explícitamente para evitar ese problema sin renombrar la clase.
const EditRecursoWithGuard = (props) => {
    const { registerFormGuard, clearFormGuard, requestNavigation } = useUnsavedChanges();
    return React.createElement(edit_recurso, { ...props, registerFormGuard, clearFormGuard, requestNavigation });
};

export default EditRecursoWithGuard;